import { Box, Text, VStack, useColorModeValue } from '@chakra-ui/react';
import { MATCHDAY_SCENARIO_EXAMPLES } from '@/constants/tournamentRulesCopy';

export function RulesMatchdaysTab() {
  const cardBg = useColorModeValue('gray.50', 'gray.700');
  const muted = useColorModeValue('gray.600', 'gray.400');

  return (
    <VStack spacing={4} align='stretch' w='full' pt={2}>
      <Text textAlign='center' fontSize='sm' color={muted} maxW='36rem' mx='auto' lineHeight='tall'>
        These examples show how Matchday settlement, late join, reset, and swap interact with your
        score. See During the Tournament above for the full rules.
      </Text>
      {MATCHDAY_SCENARIO_EXAMPLES.map((scenario) => (
        <Box
          key={scenario.title}
          w='full'
          p={4}
          borderRadius='md'
          bg={cardBg}
          textAlign='left'
        >
          <Text fontWeight='semibold' fontSize='sm' mb={2}>
            {scenario.title}
          </Text>
          <Text fontSize='sm' color={muted} lineHeight='tall'>
            {scenario.body}
          </Text>
        </Box>
      ))}
    </VStack>
  );
}
